export default __webpack_public_path__ + "static/media/639hz-love-connection.674aa127.mp3";